import { CirclePropsF } from '../../../../../common/redux/reducer/commonSlices/circleSlice';
import { PolygonPropsF } from '../../../../../common/redux/reducer/commonSlices/polygonSlice';

export const usegetGeofences = ({ data }: any) => {
  function getGeofences(type: 'circular' | 'polygon'): CirclePropsF[] | PolygonPropsF[] {
    return data
      ? data
          .filter((item: any) => item?.geoType === type)
          .map((item: any) => {
            return type === 'circular'
              ? {
                  id: item?.geoZoneId || item?.id,
                  center: {
                    lat: item.latAndLongDetails[0].lat,
                    lng: item.latAndLongDetails[0].lng
                  },
                  radius: item.radius * 1000
                }
              : {
                  id: item?.geoZoneId,
                  paths: item?.latAndLongDetails
                };
          })
      : [];
  }
  return { getGeofences };
};
